import React, { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { ColProps, Form, Input } from 'antd';

import PhoneInput, { isValidPhoneNumber, Value } from 'react-phone-number-input';
import ru from 'react-phone-number-input/locale/ru.json';

import 'react-phone-number-input/style.css';
import './phone-input-form-item.css';

interface IPhoneInputFormItemProps {
    value: string | undefined;
    name: string;
    label?: string;
    required?: boolean;
    requiredMessage?: string;
    disabled?: boolean;
    //  initialValue: string | undefined;
    onChange?: (e: string | undefined) => void;
    onValidate?: (e: string) => Promise<boolean>;
    onExists?: (e: string) => Promise<string>;
    wrapperCol?: ColProps;
}

const PhoneInputFormItem = (props: IPhoneInputFormItemProps) => {
    const { value, name, label, required, requiredMessage, disabled, wrapperCol, onChange, onValidate, onExists } = props;

    const [buffPhone, setBuffPhone] = useState<Value | undefined>(value as Value);

    useEffect(() => {}, [buffPhone]);

    const CustomInput = React.forwardRef((props, ref) => {
        const inputRef = useRef<any>(null);

        useImperativeHandle(ref, () => {
            return inputRef.current.input;
        }, []);
        return (
            <Input
                {...props}
                ref={inputRef}
                onChange={(e) => {
                    setBuffPhone(e.target.value as Value);
                }}
            />
        );
    });

    return (
        <Form.Item
            wrapperCol={wrapperCol}
            initialValue={value}
            required={required}
            name={name}
            label={label}
            rules={[
                { required: required, message: requiredMessage ?? 'Укажите номер мобильного телефона' },
                {
                    validator: async (_, value) => {
                        if (value == undefined) return Promise.resolve();

                        if (!isValidPhoneNumber(value)) return Promise.reject('Неверный формат мобильного телефона');

                        if (onValidate) {
                            const isPhoneValid = await onValidate(value);
                            if (!isPhoneValid) return Promise.reject('Номер не существует. Пожалуйста уточните номер мобильного телефона.');
                        }

                        if (onExists) {
                            const userLogin = await onExists(value);
                            if (!!userLogin) return Promise.reject(`Указанный номер уже принадлежит "${userLogin}".`);
                        }

                        return Promise.resolve();
                    },
                },
            ]}
        >
            <PhoneInput
                international
                labels={ru}
                defaultCountry='RU'
                disabled={disabled}
                onChange={(e) => {
                    if (onChange) onChange(e);
                }}
                // inputComponent={CustomInput}
            />
        </Form.Item>
    );
};

export default PhoneInputFormItem;
